import React from "react";
import pole from "../Assets/Images/pole.png";

import close from "../Assets/Images/close.png";
import { LiaAngleLeftSolid } from "react-icons/lia";

const RealEstateSlide3 = ({
  next,
  handleClose,
  skip,
  back,
  checked,
  setChecked,
}) => {
  return (
    <div className="mb-6 py-6 px-3 sm:px-6 border-[1.2px] border-[#F0F0F5] rounded-xl mx-auto  w-[90%]  md:w-[553px] h-[610px] max-h-[95%] bg-white flex flex-col shadow-2xl justify-start">
      <div className="flex justify-between">
        <div onClick={back} className="flex cursor-pointer items-center mb-4">
          <LiaAngleLeftSolid size={18} color="#131E3D" className="mx-[2px]  " />
          <h3 className="text-[14px] font-[400] text-[#131E3D]">Back</h3>
        </div>
        <img
          onClick={handleClose}
          src={close}
          alt="Close"
          className="cursor-pointer w-[24px] h-[24px]"
        />
      </div>
      <div className="mb-[5px] w-[48px] h-[48px] rounded-full bg-[#F1EDFB] font-[400] text-[20px] flex justify-center items-center text-[#6935D3]">
        2
      </div>

      <div className="flex gap-[3px] p-3 mt-[8px] mb-[10px]">
        <div className="w-[6px] h-[6px] bg-[#6935D3] rounded-full"></div>
        <div className="w-[6px] h-[6px] bg-[#6935D3] rounded-full"></div>
        <div className="w-[6px] h-[6px] bg-[#F2F2F7] rounded-full"></div>
      </div>

      <div className=" text-[24px] text-[#131E3D] font-[500] ">
        {" "}
        How it works?{" "}
      </div>
      <div className="flex-1  overflow-y-scroll">
        <div className=" mt-[40px]  p-2 ">
          {/* <iframe
            className="w-full"
            height="240px"
            style={{
              borderRadius: "8px",
            }}
            src={
              "https://www.youtube.com/embed/SevnLVnsDiM?si=yqdWi3kl-g2Cv4PO"
            }
            title=""
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe> */}
          {/* <img src={video} alt="" className=" w-[480px] h-[240px] " /> */}
        </div>
        <div className=" flex gap-[15px]  mt-[20px] ">
          <div className="flex  mt-[6px] flex-col gap-[2px] items-center ">
            <div className="flex flex-col items-center">
              <div className="w-[12px] h-[12px] bg-[#F1EDFB]  rounded-full  flex justify-center items-center"></div>
            </div>
            <div className="w-[2px] bg-[#F1EDFB] h-[44px]"></div>
            <div className="flex flex-col items-center">
              <div className="w-[12px] h-[12px] bg-[#F1EDFB]  rounded-full  flex justify-center items-center"></div>
            </div>
            <div className="w-[2px] bg-[#F1EDFB] h-[44px]"></div>
            <div className="flex flex-col items-center">
              <div className="w-[12px] h-[12px] bg-[#F1EDFB]  rounded-full  flex justify-center items-center"></div>
            </div>
            <div className="w-[2px] bg-[#F1EDFB] h-[44px]"></div>
            <div className="flex flex-col items-center">
              <div className="w-[12px] h-[12px] bg-[#F1EDFB]  rounded-full  flex justify-center items-center"></div>
            </div>
            <div className="w-[2px] bg-[#F1EDFB] h-[44px]"></div>
            <div className="flex flex-col items-center">
              <div className="w-[12px] h-[12px] bg-[#F1EDFB]  rounded-full  flex justify-center items-center"></div>
            </div>
            <div className="w-[2px] bg-[#F1EDFB] h-[44px]"></div>
            <div className="flex flex-col items-center">
              <div className="w-[12px] h-[12px] bg-[#F1EDFB]  rounded-full  flex justify-center items-center"></div>
            </div>
            <div className="w-[2px] bg-[#F1EDFB] h-[44px]"></div>
            <div className="flex flex-col items-center">
              <div className="w-[12px] h-[12px] bg-[#F1EDFB]  rounded-full  flex justify-center items-center"></div>
            </div>
            <div className="w-[2px] bg-[#F1EDFB] h-[44px]"></div>
            <div className="flex flex-col items-center">
              <div className="w-[12px] h-[12px] bg-[#F1EDFB]  rounded-full  flex justify-center items-center"></div>
            </div>
            <div className="w-[2px] bg-[#F1EDFB] h-[44px]"></div>
            <div className="flex flex-col items-center">
              <div className="w-[12px] h-[12px] bg-[#F1EDFB]  rounded-full  flex justify-center items-center"></div>
            </div>
            <div className="w-[2px] bg-[#F1EDFB] h-[44px]"></div>
            <div className="flex flex-col items-center">
              <div className="w-[12px] h-[12px] bg-[#F1EDFB]  rounded-full  flex justify-center items-center"></div>
            </div>
          </div>
          <div className=" w-[433px] max-w-[100%] flex flex-col  ">
            <div className="h-[60px] text-[16px] font-[400] text-[#131E3D] ">
              Halvest selects a property in a prime location
            </div>
            <div className="h-[60px] text-[16px] font-[400] text-[#131E3D] ">
              We create a special purpose vehicle (SPV company) to buy the
              property
            </div>
            <div className="h-[60px] text-[16px] font-[400] text-[#131E3D] ">
              You own a % (share) of the SPV
            </div>
            <div className="h-[60px] text-[16px] font-[400] text-[#131E3D] ">
              Management of property is assigned to a reliable and trustworthy
              property manager
            </div>
            <div className="h-[60px] text-[16px] font-[400] text-[#131E3D] ">
              Property is put up for rental or on Airbnb
            </div>
            <div className="h-[60px] text-[16px] font-[400] text-[#131E3D] ">
              You earn rental returns on a monthly or quarterly basis
            </div>
            <div className="h-[60px] text-[16px] font-[400] text-[#131E3D] ">
              You can sell your share to other investors if you are in need of
              cash at the current market value using our exit windows
            </div>
            <div className="h-[60px] text-[16px] font-[400] text-[#131E3D] ">
              Property is sold at the end of the investment period
            </div>
            <div className="h-[60px] text-[16px] font-[400] text-[#131E3D] ">
              Investors share the gain made on the sale of the property
            </div>
            <div className="h-[60px] text-[16px] font-[400] text-[#131E3D] ">
              You can reinvest in a new property
            </div>
          </div>
        </div>

        <div className="gap-[16px] flex-wrap mt-[20px] p-2 flex justify-between items-center">
          <label style={{ display: "flex", alignItems: "center" }}>
            <input
              id="checkbox"
              type="checkbox"
              checked={checked}
              onChange={(event) => {
                setChecked(event.target.checked);
              }}
              style={{
                color: "#6935D3",
                width: "14px",
                height: "14px",
                borderWidth: "3px",
                borderRadius: "16px",
                marginRight: "8px",
              }}
            />
            <h4 className="font-[500] text-[13px] text-[#9C9C9E]  ">
              Do not show this again.
            </h4>
          </label>

          <div className=" gap-[7px]  flex justify-end items-center ">
            <button
              onClick={skip}
              className="w-[149px] h-[45px] border border-[#F2F2F7] drop-shadow-custom rounded-[8px] bg-white text-[#192851] font-[500] text-[16px]"
            >
              Skip
            </button>
            <button
              onClick={next}
              className="w-[149px] h-[45px] rounded-[8px] bg-[#6935D3] text-white font-[500] text-[16px]"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RealEstateSlide3;
